import { memo, useMemo } from 'react';
import type { PaginationRenderItemParams } from '@mui/material';
import { IconButton } from '@mui/material';
import { Dots, Item } from './PaginatorItem.styles';
import { KeyboardArrowRight, KeyboardArrowLeft, MoreHoriz } from '@mui/icons-material';

export const PaginatorItem = memo(
  ({
    type,
    page,
    onClick,
    selected,
    hidePrevButton,
    hideNextButton,
    dataTestId,
    testIdPrefix,
  }: PaginationRenderItemParams & {
    hidePrevButton: boolean;
    hideNextButton: boolean;
    dataTestId?: string;
    testIdPrefix?: string;
  }) => {
    return useMemo(() => {
      switch (type) {
        case 'start-ellipsis':
        case 'end-ellipsis':
          return (
            <Dots>
              <MoreHoriz />
            </Dots>
          );
        case 'page':
          return (
            <Item
              onClick={onClick}
              selected={selected}
              data-testid={testIdPrefix ? `${testIdPrefix}-pagination-page-${page}` : `pagination-page-${page}`}>
              {page}
            </Item>
          );
        case 'previous':
          return (
            <IconButton
              color="primary"
              onClick={!hidePrevButton ? onClick : () => null}
              role="arrow_left"
              disabled={hidePrevButton}
              data-testid={dataTestId ?? (testIdPrefix ? `${testIdPrefix}-pagination-prev-button` : 'pagination-prev-button')}>
              <KeyboardArrowLeft fontSize="small" />
            </IconButton>
          );
        case 'next':
          return (
            <IconButton
              color="primary"
              onClick={!hideNextButton ? onClick : () => null}
              role="arrow_right"
              disabled={hideNextButton}
              data-testid={dataTestId ?? (testIdPrefix ? `${testIdPrefix}-pagination-next-button` : 'pagination-next-button')}>
              <KeyboardArrowRight fontSize="small" />
            </IconButton>
          );
        default:
          return <Item selected={false}>{page}</Item>;
      }
    }, [dataTestId, hideNextButton, hidePrevButton, onClick, page, selected, testIdPrefix, type]);
  }
);
